// src/components/shared/useKameraErzwingen.js
// Manuelle Übersteuerung für "Kamera-Aufnahme-Buttons anzeigen", unabhängig von der über
// useIsDesktop() erkannten Bildschirmbreite. Grund: hochauflösende Tablets werden dort
// fälschlich als Desktop eingestuft (reine Breakpoint-Erkennung), wodurch die Aufnahme-Buttons
// verschwinden, obwohl das Gerät eine Kamera hat. Da es keine 100% zuverlässige,
// auflösungsunabhängige "ist es ein Mobilgerät"-Erkennung gibt, gibt der Nutzer das stattdessen
// selbst per Häkchen an - der Wert wird in localStorage gemerkt, damit man ihn auf einem
// bestimmten Gerät nicht bei jedem Besuch neu setzen muss.
import { useState } from 'react';

const STORAGE_KEY = 'datenleser.kameraErzwingen';

export function useKameraErzwingen() {
  const [kameraErzwingen, setKameraErzwingenState] = useState(() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  });

  const setKameraErzwingen = (wert) => {
    setKameraErzwingenState(wert);
    try {
      window.localStorage.setItem(STORAGE_KEY, wert ? 'true' : 'false');
    } catch {
      // localStorage evtl. nicht verfügbar (z.B. Privatmodus) - Wert gilt dann nur für diese Sitzung.
    }
  };

  return [kameraErzwingen, setKameraErzwingen];
}

export default useKameraErzwingen;